/* Search results (Outfitters style) — sections/ref-search.liquid

   Har cheez Shopify ke apne live search se aati hai. Yeh script sirf itna
   karti hai ke filter / sort / agla safha badalne par poora safha dobara
   load na ho: wohi section Shopify se (Section Rendering API) le kar badal
   diya jata hai, aur pata (URL) bhi saath badalta hai — is liye browser ka
   "back" aur link share dono theek chalte hain.

   JavaScript band ho to kuch nahi tootta: filters ek saada <form> hai,
   "Load more" ek saada link, aur sort ke sab options asli links ki tarah
   kaam karte hain (form submit se). */
(() => {
  if (window.__rsrReady) return;
  window.__rsrReady = true;

  const SEL = '[data-rsr]';
  const VIEW_KEY = 'rsr-view';
  const root = () => document.querySelector(SEL);

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isPhone = () => window.matchMedia('(max-width: 767px)').matches;

  /* ---------- view (grid / list) ---------- */
  const readView = () => {
    try { return localStorage.getItem(VIEW_KEY) === 'list' ? 'list' : 'grid'; } catch (_) { return 'grid'; }
  };
  const paintView = () => {
    const el = root();
    if (!el) return;
    const v = readView();
    el.querySelectorAll('[data-rsr-grid]').forEach((g) => g.classList.toggle('is-list', v === 'list'));
    el.querySelectorAll('[data-rsr-view]').forEach((b) => {
      b.classList.toggle('is-active', b.dataset.rsrView === v);
    });
  };

  /* ---------- fetching ---------- */
  let seq = 0;

  const sectionUrl = (url, id) => {
    const u = new URL(url, location.origin);
    u.searchParams.set('section_id', id);
    return u.toString();
  };

  /* Drawer khula tha ya nahi, aur kaun sa group khula tha — badalne ke baad
     wapas wohi halat bahal kar di jati hai, taake screen jhatke na. */
  const snapshot = () => {
    const el = root();
    const form = el && el.querySelector('[data-rsr-filters]');
    const open = [];
    el && el.querySelectorAll('[data-rsr-grp].is-open [data-rsr-grp-head] .rsr-flt__name')
      .forEach((n) => open.push(n.textContent.trim()));
    return {
      drawer: !!(form && form.classList.contains('is-open')),
      drill: !!(form && form.classList.contains('is-drill')),
      open,
      scroll: window.scrollY,
    };
  };

  const restore = (snap) => {
    const el = root();
    if (!el) return;
    const form = el.querySelector('[data-rsr-filters]');
    if (form && snap.drawer) form.classList.add('is-open');
    if (form && snap.drill) form.classList.add('is-drill');
    el.querySelectorAll('[data-rsr-grp]').forEach((g) => {
      const name = g.querySelector('.rsr-flt__name');
      const on = !!name && snap.open.indexOf(name.textContent.trim()) > -1;
      g.classList.toggle('is-open', on);
      const head = g.querySelector('[data-rsr-grp-head]');
      if (head) head.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
    if (snap.drawer) setTitle();
    paintView();
    window.scrollTo(0, snap.scroll);
  };

  const swap = async (url, push) => {
    const el = root();
    if (!el) return;
    const id = el.dataset.sectionId;
    const mine = ++seq;
    el.classList.add('is-busy');
    const snap = snapshot();
    try {
      const res = await fetch(sectionUrl(url, id), { headers: { Accept: 'text/html' } });
      if (!res.ok) throw new Error('bad response');
      const html = await res.text();
      if (mine !== seq) return;                       /* naya request aa chuka hai */
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector(SEL);
      if (!fresh) throw new Error('section not found');
      el.innerHTML = fresh.innerHTML;
      el.dataset.count = fresh.dataset.count || el.dataset.count;
      if (push) history.pushState({ rsr: 1 }, '', url);
      restore(snap);
    } catch (_) {
      /* kuch bhi ulta ho jaye to saada safha load — shopper phir bhi pohanch jata hai */
      location.href = url;
    } finally {
      if (mine === seq) el.classList.remove('is-busy');
    }
  };

  /* form (filters + sort + q + type) se poora pata banao */
  const urlFromForm = (form) => {
    const u = new URL(form.getAttribute('action') || location.pathname, location.origin);
    const fd = new FormData(form);
    const out = new URLSearchParams();
    for (const [k, v] of fd.entries()) {
      if (String(v).trim() === '') continue;          /* khali daam ka khana chhoro */
      out.append(k, v);
    }
    u.search = out.toString();
    return u.toString();
  };

  const applyFilters = () => {
    const el = root();
    const form = el && el.querySelector('[data-rsr-filters]');
    if (!form) return;
    swap(urlFromForm(form), true);
  };

  /* ---------- phone: filters ka darwaza ---------- */
  const setTitle = () => {
    const el = root();
    const form = el && el.querySelector('[data-rsr-filters]');
    if (!form) return;
    const t = form.querySelector('[data-rsr-filters-title]');
    if (!t) return;
    if (!t.dataset.base) t.dataset.base = t.textContent.trim();
    const open = form.querySelector('[data-rsr-grp].is-open .rsr-flt__name');
    t.textContent = form.classList.contains('is-drill') && open ? t.dataset.base : t.dataset.base;
  };

  const openDrawer = () => {
    const form = root() && root().querySelector('[data-rsr-filters]');
    if (!form) return;
    form.classList.remove('is-drill');
    form.querySelectorAll('[data-rsr-grp]').forEach((g) => {
      g.classList.remove('is-open');
      const h = g.querySelector('[data-rsr-grp-head]');
      if (h) h.setAttribute('aria-expanded', 'false');
    });
    form.classList.add('is-open');
    document.documentElement.classList.add('rsr-lock');
  };

  const closeDrawer = () => {
    const form = root() && root().querySelector('[data-rsr-filters]');
    if (!form) return;
    form.classList.remove('is-open', 'is-drill');
    document.documentElement.classList.remove('rsr-lock');
  };

  /* ---------- load more ---------- */
  let loading = false;

  const loadMore = async () => {
    const el = root();
    const box = el && el.querySelector('[data-rsr-more]');
    if (!box || loading) return;
    const next = box.dataset.next;
    if (!next) return;
    loading = true;
    box.classList.add('is-busy');
    try {
      const res = await fetch(sectionUrl(next, el.dataset.sectionId), { headers: { Accept: 'text/html' } });
      if (!res.ok) throw new Error('bad response');
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const grid = el.querySelector('[data-rsr-grid]');
      const more = doc.querySelector('[data-rsr-grid]');
      if (!grid || !more) throw new Error('grid not found');
      const frag = document.createDocumentFragment();
      more.querySelectorAll('.rsr-card').forEach((c) => frag.appendChild(c));
      grid.appendChild(frag);
      const nextBox = doc.querySelector('[data-rsr-more]');
      if (nextBox && nextBox.dataset.next) {
        box.dataset.next = nextBox.dataset.next;
        const a = box.querySelector('a');
        if (a) a.href = nextBox.dataset.next;
      } else {
        box.remove();
      }
      history.replaceState(history.state, '', next);
    } catch (_) {
      const a = box.querySelector('a');
      if (a) location.href = a.href;
    } finally {
      loading = false;
      box.classList.remove('is-busy');
    }
  };

  /* neeche pohanchne par agla safha khud jur jata hai */
  const watchBottom = () => {
    let raf = 0;
    const tick = () => {
      raf = 0;
      const el = root();
      const box = el && el.querySelector('[data-rsr-more]');
      if (!box || loading) return;
      const r = box.getBoundingClientRect();
      if (r.top < innerHeight + 400) loadMore();
    };
    const onScroll = () => { if (!raf) raf = requestAnimationFrame(tick); };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  };

  /* ---------- ek hi jagah se saare click ---------- */
  document.addEventListener('click', (e) => {
    const el = root();
    if (!el) return;

    const view = e.target.closest('[data-rsr-view]');
    if (view && el.contains(view)) {
      e.preventDefault();
      /* phone par ek hi button hai: har dabane par halat badal jati hai */
      const want = isPhone()
        ? (readView() === 'grid' ? 'list' : 'grid')
        : view.dataset.rsrView;
      try { localStorage.setItem(VIEW_KEY, want); } catch (_) {}
      paintView();
      return;
    }

    const sortOpt = e.target.closest('[data-rsr-sort-value]');
    if (sortOpt && el.contains(sortOpt)) {
      e.preventDefault();
      const form = el.querySelector('[data-rsr-filters]');
      const u = new URL(form ? urlFromForm(form) : location.href, location.origin);
      u.searchParams.set('sort_by', sortOpt.dataset.rsrSortValue);
      u.searchParams.delete('page');
      const box = el.querySelector('[data-rsr-sort]');
      if (box) box.removeAttribute('open');
      swap(u.toString(), true);
      return;
    }

    const openBtn = e.target.closest('[data-rsr-open-filters]');
    if (openBtn && el.contains(openBtn)) { e.preventDefault(); openDrawer(); return; }

    const closeBtn = e.target.closest('[data-rsr-close-filters]');
    if (closeBtn && el.contains(closeBtn)) { e.preventDefault(); closeDrawer(); return; }

    const back = e.target.closest('[data-rsr-filters-back]');
    if (back && el.contains(back)) {
      e.preventDefault();
      const form = el.querySelector('[data-rsr-filters]');
      if (form) {
        form.classList.remove('is-drill');
        form.querySelectorAll('[data-rsr-grp]').forEach((g) => {
          g.classList.remove('is-open');
          const h = g.querySelector('[data-rsr-grp-head]');
          if (h) h.setAttribute('aria-expanded', 'false');
        });
      }
      return;
    }

    const head = e.target.closest('[data-rsr-grp-head]');
    if (head && el.contains(head)) {
      e.preventDefault();
      const grp = head.closest('[data-rsr-grp]');
      const form = el.querySelector('[data-rsr-filters]');
      const phoneDrawer = isPhone() && form && form.classList.contains('is-open');
      if (phoneDrawer) {
        /* phone: us group ke andar chale jao */
        el.querySelectorAll('[data-rsr-grp]').forEach((g) => g.classList.toggle('is-open', g === grp));
        form.classList.add('is-drill');
        head.setAttribute('aria-expanded', 'true');
        const groups = form.querySelector('.rsr-flt__groups');
        if (groups) groups.scrollTop = 0;
      } else {
        const on = !grp.classList.contains('is-open');
        grp.classList.toggle('is-open', on);
        head.setAttribute('aria-expanded', on ? 'true' : 'false');
      }
      return;
    }

    const more = e.target.closest('.rsr__more-btn');
    if (more && el.contains(more)) { e.preventDefault(); loadMore(); return; }

    const reset = e.target.closest('[data-rsr-reset], .rsr-flt__clear');
    if (reset && el.contains(reset)) {
      e.preventDefault();
      closeDrawer();
      swap(reset.getAttribute('href'), true);
      return;
    }

    /* sort ki list ke bahar click: list band */
    const sortBox = el.querySelector('[data-rsr-sort][open]');
    if (sortBox && !e.target.closest('[data-rsr-sort]')) sortBox.removeAttribute('open');
  });

  /* checkbox / daam ka khana badalte hi natije badal jaate hain */
  let priceTimer = 0;
  document.addEventListener('change', (e) => {
    const el = root();
    if (!el || !e.target.closest('[data-rsr-filters]')) return;
    if (e.target.matches('[data-rsr-val]')) { applyFilters(); return; }
    if (e.target.matches('[data-rsr-price]')) {
      clearTimeout(priceTimer);
      priceTimer = setTimeout(applyFilters, 450);
    }
  });
  document.addEventListener('input', (e) => {
    if (!e.target.matches('[data-rsr-price]')) return;
    clearTimeout(priceTimer);
    priceTimer = setTimeout(applyFilters, 650);
  });

  /* "Show N products" — darwaza band karo, natije pehle hi lag chuke hain */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-rsr-filters]');
    if (!form) return;
    e.preventDefault();
    closeDrawer();
    swap(urlFromForm(form), true);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const form = root() && root().querySelector('[data-rsr-filters].is-open');
    if (form) closeDrawer();
  });

  window.addEventListener('popstate', () => {
    if (root()) swap(location.href, false);
  });

  paintView();
  watchBottom();
  document.addEventListener('shopify:section:load', paintView);
})();
